import styled from "styled-components";

export const ToggleWrapper = styled.button<{
  checked: boolean;
  disabled?: boolean;
}>`
  position: relative;
  width: 35px;
  height: 20px;
  background-color: ${({ checked }) => (checked ? "#34c759" : "#ff0000")};
  border-radius: 999px;
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: background-color 0.5s ease;
  padding: 0;
`;

export const Thumb = styled.div<{ checked: boolean }>`
  position: absolute;
  top: 3px;
  left: ${({ checked }) => (checked ? "calc(100% - 17px)" : "3px")};
  width: 14px;
  height: 14px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.25s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
`;
